import { APPLE_PAY_METHOD_ID } from "../ApplePayHandler";
import { GOOGLE_PAY_METHOD_ID } from "../GooglePayHandler";

export interface PaymentResponse {
  methodName: string
  details: object
  requestId: string
}

export interface ApplePayPaymentResponse extends PaymentResponse {
  details: {
    token: {
      paymentData: object
    }
  }
}

export interface GooglePayPaymentResponse extends PaymentResponse {
  details: {
    paymentMethodData: {
      tokenizationData: {
        token: string
      }
    }
  }
}

export function isApplePayPaymentResponse(obj: any): obj is ApplePayPaymentResponse {
  return obj?.methodName === APPLE_PAY_METHOD_ID
    && typeof obj?.details?.token?.paymentData !== 'undefined';
}


export function isGooglePayPaymentResponse(obj: any): obj is GooglePayPaymentResponse {
  return obj?.methodName === GOOGLE_PAY_METHOD_ID
    && typeof obj?.details?.paymentMethodData?.tokenizationData?.token !== 'undefined';
}